import { Box } from '@zillow/constellation-10';

const UpsellStep = () => {
  return <Box data-testid="UpsellStep">UpsellStep</Box>;
};

export default UpsellStep;
